"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Recognition() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: logosRef,
    isVisible: logosVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: statsRef,
    isVisible: statsVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const awards = [{
    name: "SIGO",
    subtitle: "SOCIETÀ ITALIANA GINECOLOGIA E OSTETRICIA"
  }, {
    name: "AGUI",
    subtitle: "Associazione Ginecologi Universitari"
  }, {
    name: "ESHRE",
    subtitle: "Human Reproduction Expert"
  }, {
    name: "AOGOI",
    subtitle: "ASSOCIATAZIONE ITALIANA OSTETRICI E GINECOLOGI OSPEDALIERI"
  }, {
    name: "ISUOG",
    subtitle: "International Society of Ultrasound in Obstetrics and Gynecology"
  }, {
    name: "SIEOG",
    subtitle: "SOCIETA' ITALIANA DI ECOGRAFIA OSTETRICO-GINECOLOGICA"
  }, {
    name: "Forensic",
    subtitle: "Legal Medicine Expert"
  }];
  return <section data-section-id="590" id="riconoscimenti-e-affiliazioni" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={headerRef} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-default text-xs tracking-[0.15em] uppercase text-muted-foreground mb-8">&nbsp;Affiliazioni</span>

          <h2 className="font-default text-foreground leading-[1.2] max-w-3xl mx-auto" style={{
          fontSize: "clamp(2rem, 5vw, 3rem)"
        }}>
            Eccellenza clinica e rigore scientifico riconosciuti.
          </h2>

          {}
          <div className="mt-12 mb-12 h-px w-10 bg-border" aria-hidden="true" />
        </div>

        {}
        <div ref={logosRef} className={`transition-all duration-700 ease-out delay-150 ${logosVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-y-10">
            {awards.map((award, i) => <div data-index={i} key={award.name} className="group relative flex flex-col items-center justify-center text-center px-4 py-2 opacity-60 hover:opacity-100 transition-opacity duration-[400ms] ease-in-out">
                {}
                {i !== 0 && <span aria-hidden="true" className="hidden lg:block absolute left-0 top-1/2 -translate-y-1/2 h-10 w-px bg-border" />}

                <span className="font-default text-2xl md:text-xl lg:text-2xl text-foreground tracking-tight">
                  {award.name}
                </span>
                <span className="font-default text-[10px] tracking-[0.15em] uppercase text-muted-foreground mt-2 leading-relaxed">
                  {award.subtitle}
                </span>
              </div>)}
          </div>
        </div>

        {}
        <div ref={statsRef} className={`mt-20 flex justify-center transition-all duration-700 ease-out delay-300 ${statsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <p className="font-default text-xs sm:text-sm tracking-[0.15em] uppercase text-muted-foreground text-center flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
            <span>Specialista in ginecologia e ostetricia</span>
            <span className="text-border" aria-hidden="true">·</span>
            <span>Esperto in fisiopatologia della Riproduzione umana</span>
            <span className="text-border" aria-hidden="true">·</span>
            <span>Consulente tecnico Forense</span>
          </p>
        </div>
      </div>
    </section>;
}